export default "__VITE_ASSET__DXf3QJ1U__"